
import { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
  hover?: boolean;
}

export const Card = ({ children, className = '', hover = false }: CardProps) => {
  const hoverClasses = hover ? 'hover:scale-[1.02] hover:shadow-xl transition-all duration-300' : '';
  
  return (
    <div className={`bg-white rounded-2xl shadow-lg p-6 ${hoverClasses} ${className}`}>
      {children}
    </div>
  );
};
